import { CreateOrUpdatePromoPayload, PromoLoyaltyMetaConfig } from '~/services/PromoService';

type LoyaltyBonusApplyMethod = PromoLoyaltyMetaConfig['loyaltyBonusFilterMethods'][number]['key'];

export function normalizeLoyaltyBonusApplyMethod(
  value: LoyaltyBonusApplyMethod | string | null | undefined,
): CreateOrUpdatePromoPayload['promo']['loyalty_bonus_apply_method'] {
  if (!value) {
    return 'none';
  }

  return value.toLowerCase() as CreateOrUpdatePromoPayload['promo']['loyalty_bonus_apply_method'];
}
